var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHitronPbLockupRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 226.8",
    style: {
      enableBackground: "new 0 0 566.9 226.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004C97;}\n\t.st1{fill:#009CE5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M488.7,44.6c0-1.6-1.2-2.9-2.9-2.9h-4.1v5.8h4C487.5,47.5,488.7,46.3,488.7,44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307,41.6c-4.9,0-8.7,3.9-8.7,8.8c0,5,3.8,8.8,8.7,8.8c4.9,0,8.7-3.9,8.7-8.8C315.6,45.6,311.9,41.6,307,41.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M447.1,42h-4v16.6h4c7,0,8.9-3.7,8.9-8.2C456,45.7,454.1,42,447.1,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.3,27.6v51.7h262.3c11.4,0,20.6-9.2,20.6-20.6V22.1H259.8C256.8,22.1,254.3,24.5,254.3,27.6z M280.3,55.3 h-5.6v9h-6.1V36.5h11.7c4.2,0,9.3,3.3,9.3,9.4C289.6,51.5,284.9,55.3,280.3,55.3z M307,64.8c-8.2,0-14.8-6.3-14.8-14.4 c0-8,6.6-14.4,14.8-14.4c8.2,0,14.8,6.3,14.8,14.4C321.8,58.5,315.2,64.8,307,64.8z M349.9,65.3l-8.7-17l-8.7,17l-10.1-28.8h6.2 l5.1,14.6l7.5-14.8l7.5,14.8l5.1-14.6h6.2L349.9,65.3z M382.6,64.2h-19.2V36.5h18.9V42h-12.8v5.2h12v5.4h-12v5.9h13.1V64.2z  M403.1,64.2l-5.8-9.2h-0.1h-4v9.2h-6.1V36.5h11.6c5.2,0,9.4,4,9.4,9.1c0,3.6-2,6.6-4.9,7.9l6.8,10.7H403.1z M432.4,64.2h-19.2 V36.5h18.9V42h-12.8v5.2h12v5.4h-12v5.9h13.1V64.2z M447.5,64.2H437V36.5h10.5c9.7,0,14.7,5.9,14.7,13.9 C462.2,58.6,457.2,64.2,447.5,64.2z M488.2,64.2h-12.5V36.5h11c4.4,0,7.9,3,7.9,7.1c0,2.7-1.3,4.8-3.5,5.6 c3.7,0.6,5.6,3.4,5.6,6.9C496.7,60.7,493.1,64.2,488.2,64.2z M512.7,53.9v10.3h-6.1V53.9l-10.2-17.4h6.6l6.6,11.5l6.6-11.5h6.6 L512.7,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.9,42h-5.2v7.6h5.2c1.2,0,3.6-0.8,3.6-3.8C283.5,42.8,281.2,42,279.9,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.6,42h-5.4v7.5h4.9c2.4,0,4-1.5,4-3.9C402,43.6,400.5,42,398.6,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487,52.3h-5.3v6.6h5.3c2.1,0,3.6-1.5,3.6-3.4C490.6,53.7,489.1,52.3,487,52.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.4,69.7c-8.9,0-15.2,7.6-15.2,15c0,8.4,6.3,16.4,15.6,16.4c9.7,0,15.8-8,15.8-16.4 C173.5,77.1,166.4,69.7,157.4,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254,194.3l-3.4-9.6c-3.7,1.8-7.1,3.5-13,3.5c-8.9,0-14-5.4-14-23.8v-38.3h21.2c3.2,0,5.8-2.6,5.8-5.8v-8.9 h-27V85.2c0,0-3.3,0-7.4,0c-3.6,0-4.8,2.6-4.8,2.7c-8.5,15.1-24.1,26.1-29.1,27.2v10.9h14.2v46.1c0,20.7,9.8,32.5,32.1,32.5 c7.8,0,16.2-1.7,23.5-5C255.5,198.1,254,194.3,254,194.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428.7,150.8c-2.8-29.5-28.9-44.2-54.6-41.7c-25.6,2.5-48.3,21.9-45.5,51.4c2.7,28.2,24.9,46.8,54.7,44 C413.2,201.5,431.4,179,428.7,150.8z M381.9,189.9c-17.6,1.7-24.2-16.5-25.7-32.1c-1.4-14.6,2.5-32.7,19.3-34.3 c17.2-1.7,24.2,15.3,25.7,29.9C402.6,169,399.8,188.2,381.9,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.9,109c-8.3,0-14.2,8.1-17.5,12.4l-5.5,7.9h-0.4v-17.9h-21c-3.2,0-5.8,2.6-5.8,5.8v4.2v80.8h21.2 c3.2,0,5.8-2.6,5.8-5.8v-33.6c0-21.9,9.1-29.4,18.5-29.4c5.5,0,9,1.5,12.8,3.5c3.5-11,10.2-18.7,10.2-18.7 C327.4,112.2,320.9,109,314.9,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.5,109c-12.8,0-25.6,4.7-34.7,14.4v-12h-21c-3.2,0-5.8,2.6-5.8,5.8l0,0v85h21.2c3.2,0,5.8-2.6,5.8-5.8 V156c0-16.7,10.4-29,23.6-29c14,0,20.3,9.3,20.3,23.6v51.6h21.2c3.2,0,5.8-2.6,5.8-5.8v-48.8C537.9,122,525.3,109,501.5,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.6,109c-12.8,0-25.6,4.7-34.7,14.4v-45h-21c-3.2,0-5.8,2.6-5.8,5.8v118h21.2c3.2,0,5.8-2.6,5.8-5.8V156 c0-16.7,10.4-29,23.5-29c14,0,20.3,9.3,20.3,23.6v51.6h21.2c3.2,0,5.8-2.6,5.8-5.8v-48.8C126.9,122,114.3,109,90.6,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.8,115.2c-11.8,0-21.4,9.6-21.4,21.4v65.6h21.2c3.2,0,5.8-2.6,5.8-5.8v-81.2H165.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitronPbLockupRgb);
export default __webpack_public_path__ + "static/media/HITRON-pb-lockup-rgb.57821a21fc43846fdb179fcb8724871c.svg";
export { ForwardRef as ReactComponent };